import React from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { Paprika } from '../../styles/theme';

interface InlineAnswerProps {
  answer: string | null;
  isLoading: boolean;
}

export const InlineAnswer: React.FC<InlineAnswerProps> = ({ answer, isLoading }) => {
  if (!isLoading && !answer) return null;

  return (
    <View style={styles.container}>
      <View style={styles.avatar}>
        <Text style={styles.avatarText}>✦</Text>
      </View>
      <View style={styles.bubble}>
        {isLoading ? (
          <ActivityIndicator size="small" color={Paprika.ai} />
        ) : (
          <Text style={styles.answerText}>{answer}</Text>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 12,
    paddingHorizontal: 18,
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: Paprika.aiSoft,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  avatarText: {
    fontSize: 14,
    color: Paprika.ai,
  },
  bubble: {
    flex: 1,
    backgroundColor: Paprika.aiTint,
    borderRadius: 12,
    padding: 12,
    minHeight: 40,
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Paprika.aiDots,
  },
  answerText: {
    fontFamily: 'Inter-Regular',
    fontSize: 14,
    lineHeight: 20,
    color: Paprika.textPrimary,
  },
});
